import { useMemo } from 'react';

import { TEMPLATE_STATUS } from 'src/data/template';
import { usePreparedMultiPromptTemplates } from 'src/services';

export const useReleasedMultiPromptTemplates = () => {
  const preparedTemplates = usePreparedMultiPromptTemplates();

  return useMemo(() => {
    return preparedTemplates.filter((template) => template.status === TEMPLATE_STATUS.released);
  }, [preparedTemplates]);
};
